import React, { useEffect, createElement } from 'react';
const CLARITY_ID = 'wvxq9eqjfn';
declare global {
  interface Window {
    clarity?: any;
  }
}
export function MicrosoftClarity() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if ((window as any).__CLARITY_LOADED__) return;
    (window as any).__CLARITY_LOADED__ = true;
    (function (c: any, l: Document, a: string, r: string, i: string) {
      c[a] = c[a] || function () {
        ;
        (c[a].q = c[a].q || []).push(arguments);
      };
      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/' + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode?.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_ID);
  }, []);
  return null;
}